export default __webpack_public_path__ + "static/media/drum.9104e77f.png";